import type { Plan } from '@/modules/plans/types'

// Retorna o percentual de desconto configurado no plano
// `billingInterval` permite forçar a leitura como mensal ou anual (SSOT compartilhado entre Home e Checkout)
export function getPlanDiscountPercent(p: Plan, billingInterval?: 'month' | 'year'): number {
  const meta: any = p?.meta || {}
  const interval = billingInterval || p.interval
  if (interval === 'year') {
    const apct = Number(meta?.annual_discount_percent)
    return Number.isFinite(apct) ? Math.max(0, Math.min(99, Math.floor(apct))) : 0
  }
  const raw = (typeof meta?.discount_percent === 'number'
    ? meta.discount_percent
    : (typeof meta?.discount?.percent === 'number' ? meta.discount.percent : 0))
  const n = Number(raw)
  return Number.isFinite(n) ? Math.max(0, Math.min(99, Math.floor(n))) : 0
}

// Recorrência do desconto mensal (one_time | recurring)
export function getPlanDiscountRecurrence(p: Plan): 'one_time' | 'recurring' {
  const meta: any = p?.meta || {}
  const rec = String(meta?.discount_recurrence ?? meta?.discount?.recurrence ?? 'recurring').toLowerCase()
  return rec === 'one_time' ? 'one_time' : 'recurring'
}

// Aplica apenas o desconto do plano (sem cupom). Retorna valor em cents
export function getPriceAfterPlanDiscount(p: Plan): number {
  const base = Number(p?.amount_cents || 0)
  const pct = getPlanDiscountPercent(p)
  if (!Number.isFinite(base) || base <= 0) return 0
  if (!pct || pct <= 0) return base
  return Math.max(0, Math.floor(base * (100 - pct) / 100))
}
